/**
 * 描述：http请求服务
 * 日期：2017-6-13
 * 作者：bai.zhiming
 */
"use strict";
angular.module("httpServiceModule", [])
    .factory("httpService", ["$http", "$state", "$stateParams", "$q", 'modalDialog', function($http, $state, $stateParams, $q, modalDialog) {
        return {
            notLogin: false,
            http: function(url, params, type, forbiddenModal, showError, headers) {
                var self = this;
                var deffer = $q.defer();
                $http({
                    method: !!type ? type : 'get',
                    url: url,
                    headers: Object.assign(headers || {
                        'formdata': "1",
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        'requestToken':sessionStorage.getItem('requestToken')
                    }, {'tenantId':params&&params.tenantId || localStorage.getItem('loginUser')&&JSON.parse(localStorage.getItem('loginUser')).tenantId || sessionStorage.getItem('ls.curUserInfo')&&JSON.parse(sessionStorage.getItem('ls.curUserInfo')).TENANTID}),
                    data: type == 'post' ? params : "",
                    params: type == 'post' ? "" : params
                }).then(function(response) {
                	var data = angular.ProcessingData(response.data);
                    if (data.success === false) {
                        //debugger
//                      if (self.notLogin) return;
                        if(data.mcnUserNotExists){
                        	modalDialog.alertType("提示", "当前登录用户未同步到MCN系统，请联系系统管理员", "warning", false, function() {});
                        	return;
                        }
                        if (data.noLogin) {
                            //self.notLogin = true;
                            
                            // modalDialog.alertType("错误", data.message, "warning", false);
                            if(!data.enableIDS && data.loginUrl){
                            	$state.go("backstageLogin", { orgurl: $state.current.name, orgparams: JSON.stringify($stateParams) });
                            	return;
                            }
                            if(data.enableIDS && data.loginUrl){
                            	window.location.href=data.loginUrl;
                            	return;
	                        }
                            $state.go("login", { orgurl: $state.current.name, orgparams: JSON.stringify($stateParams) });
                            return;
                            
                        }
                        if (showError) {
                            deffer.resolve(data);
                            // return;
                        } else {
                            deffer.reject(data);
                            // return;
                        }
                        if (!forbiddenModal) {
                            modalDialog.alertType("错误", data.message, "error", false);
                        }

                    } else if (data.status === 0) {
                        if (!forbiddenModal) modalDialog.alertType("成功", data.content, "success", false);
                        deffer.resolve(data);
                    } else if (data.status === 2) {
                        modalDialog.alertType("警告", "您尚未登录该系统", "warning", false, function() {});
                    } else {
                        deffer.resolve(data);
                    }
                }, function(response) {
                    deffer.reject();
                });
                return deffer.promise;
            },
        };
    }]).config(['$httpProvider', function($httpProvider) {

        /**
         * The workhorse; converts an object to x-www-form-urlencoded serialization.
         * @param {Object} obj
         * @return {String}
         */
        function toFormData(obj) {
            var query = '';
            var name, value, fullSubName, subName, subValue, innerObj, i;

            for (name in obj) {
                value = obj[name];

                if (value instanceof Array) {
                    for (i = 0; i < value.length; ++i) {
                        subValue = value[i];
                        fullSubName = name; //name + '[' + i + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += toFormData(innerObj) + '&';
                    }
                } else if (value instanceof Object) {
                    for (subName in value) {
                        subValue = value[subName];
                        fullSubName = name + '[' + subName + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += toFormData(innerObj) + '&';
                    }
                } else if (value !== undefined && value !== null) {
                    query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                }
            }
            return query.length ? query.substr(0, query.length - 1) : query;
        }
        // 浏览器缓存设置
        // if (!$httpProvider.defaults.headers.get) {
        //     $httpProvider.defaults.headers.get = {};
        // }
        // $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
        // $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';
        $httpProvider.defaults.transformRequest = [function(data) {
            // getTenantId(data);
            return angular.isObject(data) && String(data) !== '[object File]' ? toFormData(data) : data;
        }];
        // function getTenantId(params) {
        //     try {
        //         if (!params.tenantId) {
        //             const userInfo = JSON.parse(localStorage.getItem('loginUser') || sessionStorage.getItem('ls.curUserInfo'));
        //             params.tenantId = userInfo.tenantId || userInfo.TENANTID; 
        //         }
        //     } catch(err) {}
        // }
    }]);